import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

// Get DB translations for a specific locale (any authenticated user)
export const getTranslationsForLocale = async (token, locale) => {
  log("welcome in getTranslationsForLocale")

  if (!token || token === "") {
    return { error: true, message: "No token provided", translations: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_translations_for_locale_api?locale=' + encodeURIComponent(locale)

    const result = await axios.get(url, { headers })
    log("result.data from getTranslationsForLocale")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getTranslationsForLocale")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching translations", translations: [] }
  }
}

// Get all translations for CRUD page (admin only)
export const getTranslations = async (token, locale, search, section) => {
  log("welcome in getTranslations")

  if (!token || token === "") {
    return { error: true, message: "No token provided", translations: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_translations_api?'
    if (locale) url += 'locale=' + encodeURIComponent(locale) + '&'
    if (search) url += 'search=' + encodeURIComponent(search) + '&'
    if (section) url += 'section=' + encodeURIComponent(section) + '&'

    const result = await axios.get(url, { headers })
    log("result.data from getTranslations")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getTranslations")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching translations", translations: [] }
  }
}

// Save (create or update) a translation
export const saveTranslation = async (token, data) => {
  log("welcome in saveTranslation")
  log(data)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/save_translation_api'

    const result = await axios.post(url, data, { headers })
    log("result.data from saveTranslation")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in saveTranslation")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving translation" }
  }
}

// Delete a translation (reset to default)
export const deleteTranslation = async (token, id) => {
  log("welcome in deleteTranslation")

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/delete_translation_api'

    const result = await axios.post(url, { id: id }, { headers })
    log("result.data from deleteTranslation")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in deleteTranslation")
    log(err)
    error.value = err.message
    return { error: true, message: "Error deleting translation" }
  }
}

const useTranslationsAPI = () => {
  return { error, getTranslationsForLocale, getTranslations, saveTranslation, deleteTranslation }
}

export default useTranslationsAPI
